import { DebugService } from './shared/services/debug.service.js';
import { ApiService } from './core/services/api/api.service.js';
import { OffersService } from './offers/offers.service.js';
import { REFI_OFFERS_CONST } from './shared/constants/app.constants.js';
import { SessionService } from './core/services/session/session.service.js';
import { Router } from './router.js';
import { CookieService } from './core/services/cookie/cookie.service.js';
import { stratum } from '../constants/stratum.js';
import { appStoreService } from './app.store.js';

class _AppService {
  LOB_ID = '253';

  constructor() {
    this.debug = new DebugService('AppService');
    this.testingParam = new URL(window.location.href).searchParams.get('testing');
    if (this.testingParam && !REFI_OFFERS_CONST.isProdEnv) {
      this.session = SessionService.mockSession;
    } else {
      this.session = SessionService.session || {};
    }
    this._state = {
      appStatus: this.session.currentApp?.appStatusId,
      statFlag: this.session.currentApp?.statFlag,
    };
    this._appExpDate = new Date(this.session.currentApp?.validityEndDate);
    this.status = '';
    this._hasStips = false;
    document.dispatchEvent(new CustomEvent('glia-add-custom-attributes', { detail: { AppId: this.session.currentApp?.appId || '' } }));
  }

  get appExpDate() {
    this.debug.log('getting appExpDate', this._appExpDate);
    return this._appExpDate.toLocaleDateString('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  get status() {
    this.debug.log('getting status', this._status);
    return this._status;
  }

  set status(status) {
    this._status = status;
  }

  get state() {
    return this._state;
  }

  set state(state) {
    this._state = state;
  }

  get borrowerFirstName() {
    return this.customerDetails?.borrowerFirstName?.trim();
  }

  get hasStips() {
    return this._hasStips;
  }

  set hasStips(hasStips) {
    this._hasStips = hasStips;
    document.dispatchEvent(
      new CustomEvent('refi-stips-update', {
        detail: this._hasStips,
      }),
    );
  }

  async getApplicationInfo() {
    // const isBuildYourOffer = ExperienceOffersService.isEnabled(); // replace with Oasis check if BYO ever comes back
    this.debug.log('getApplicationInfo called');
    // this.debug.log('is build your offer: ', isBuildYourOffer);
    let res;
    try {
      const headers = {
        headers: {
          C1_PRID: CookieService.getCookie('C1_PRID'),
        },
      };

      this.debug.log(headers.headers.C1_PRID ? 'Able to obtain C1_PRID value from Cookie' : 'Unable to obtain C1_PRID value from Cookie');

      const { eAppId } = this.session;
      if (!eAppId || this.session?.currentApp?.statFlag !== 11) {
        return null;
      }
      const regex = new RegExp(/^\d{1,2}\/\d{1,2}\/\d{4}$/);
      const formatAppReceivedDate = dateString => {
        const date = new Date(dateString);
        return (date.getMonth() + 1).toString().concat('/', date.getDate().toString(), '/', date.getFullYear().toString());
      };

      let appReceivedDate;

      if (this.session?.currentApp?.appReceivedDate) {
        appReceivedDate = regex.test(this.session.currentApp.appReceivedDate) ? this.session.currentApp.appReceivedDate : formatAppReceivedDate(this.session.currentApp.appReceivedDate);
      }

      const lobId = appReceivedDate ? this.LOB_ID.concat('APP_RECEIVED_DATE=', appReceivedDate) : this.LOB_ID;
      // lobId = isBuildYourOffer ? lobId.concat('-BUILD_YOUR_OFFERS') : lobId;
      const body = { lobId };

      // Offers Bff Application Testing
      try {
        res = await ApiService.post(`${REFI_OFFERS_CONST.OFFERS_BFF_URL}${eAppId}/offers`, body, headers);
      } catch {
        this.debug.error('Unable to get response for offers call');
      }

      this.debug.log('call successful', res);
      const currentLoan = {
        currentMonthlyPayment: res.currentLoanDetail?.currentMonthlyPayment,
        remainingPayment: res.currentLoanDetail?.remainingPayment,
        calculatedRemainingPayment: res.currentLoanDetail?.currentMonthlyPayment,
        apr: res.currentLoanDetail?.apr >= 0 ? res.currentLoanDetail?.apr : null,
        lenderInfo: {
          lienHolderName: res.currentLoanDetail?.lenderName,
          lienHolderAccountNumber: res.currentLoanDetail?.lenderAccountNumber,
        },
        loanStatus: res.currentLoanDetail?.loanStatus,
      };
      OffersService.currentLoan = currentLoan;
      OffersService.hasStips = res.hasStips;
      OffersService.hasSavings = res.hasSavings;
      SessionService.updateCurrentloan(currentLoan.lenderInfo);

      if (res.offersDetail?.offers?.length > 25) {
        stratum.publishTag(`NR_RPO_GREATER_THAN_25`);
      }
      if (res.offersDetail?.offers?.some(offer => offer.crdtPlcyViolation)) {
        stratum.publishTag(`NR_RPO_OFFERS_OUTSIDE`);
      }
      OffersService.setOffers(res.offersDetail?.offers);
      this.offers = OffersService.offers;
      appStoreService.loadingApp(false);
      return res;
    } catch (err) {
      this.debug.log('call failed', err);
      throw err;
    }
  }

  async getMockApplicationInfo() {
    const currentLoan = {
      currentMonthlyPayment: 223.0,
      remainingPayment: 36,
      calculatedRemainingPayment: 223.0,
      apr: 3.375,
    };
    OffersService.currentLoan = currentLoan;
    OffersService.setOffers([
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 443.57,
        term: 24.0,
        offerId: 1,
        marketedOffer: false,
        savings: {
          lifetimeSavings: 5662.64,
          monthlySavings: 54.28,
        },
      },
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 410.84,
        term: 25.0,
        offerId: 2,
        marketedOffer: false,
      },
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 405.85,
        term: 26.0,
        offerId: 3,
        marketedOffer: false,
      },
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 397.64,
        term: 27.0,
        offerId: 4,
        marketedOffer: false,
      },
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 396.43,
        term: 28.0,
        offerId: 5,
        marketedOffer: false,
      },
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 370.44,
        term: 29.0,
        offerId: 6,
        marketedOffer: false,
      },
      {
        operationSuccessful: true,
        crdtPlcyViolation: false,
        offerApr: 4.31,
        offerPayment: 325.34,
        term: 30.0,
        offerId: 7,
        marketedOffer: false,
      },
    ]);
  }

  updateState({ appStatus = this.state.appStatus, statFlag = this.state.statFlag }) {
    this.debug.log('updateState called with', {
      appStatus,
      statFlag,
    });
    this.state = { appStatus, statFlag };
    if (appStatus) {
      SessionService.session = { appStatusId: appStatus, statFlag };
    }
    this.updateRoute(this.state);
  }

  updateRoute(state) {
    this.debug.log('routing with state', state);
    switch (Number(state.appStatus)) {
      case 402:
        this._status = 'invalid-offer';
        break;
      case 404:
        this._status = 'verifying-offer';
        break;
      case 405:
      case 406:
      case 407:
      case 408:
        this._status = this.setStateFromStatFlag(state);
        break;
      default:
        this._status = 'reviewing-offer';
    }

    Router.goTo(`${this._status}`);
    Router.sendStateChangedEvent(`${this._status}`);
  }

  setStateFromStatFlag(state) {
    switch (Number(state.statFlag)) {
      case 11:
        return this.determineOffersPage();
      default:
        return '';
    }
  }

  determineOffersPage() {
    if (window.location.href.includes('review-offer')) {
      return REFI_OFFERS_CONST.PAGE_NAMES.REVIEW_OFFER_CARD;
    }

    return REFI_OFFERS_CONST.PAGE_NAMES.OFFER;
  }
}

export const AppService = new _AppService();
